import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import MainLayout from './layouts/mainLayout';
import { publicRoutes, publicRoutesForSecondLayout } from './routes/routes';
import ProtectedRoute from './routes/protectedRoutes';
import AdminRoutes from './routes/AdminRoutes';
import UserRoutes from './routes/UserRoutes';
import './css/global.css'
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme/theme';
import OrganizationLayout from './layouts/OrganizationLayout';
import './assets/css/freeVideoCss/free-video.css';
import './components/HomePage/css/styles.css';
import './assets/css/responsive.css';
import PageTracker from './pageTracker';

function App() {

  return (
    <div className="App" id='nav-body'>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <PageTracker />
          {/* Main Layout for public routes */}
          <Routes>
            {/* Public Routes */}
            {publicRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

            <Route element={<OrganizationLayout />}>
              {publicRoutesForSecondLayout.map(({ path, element }, index) => (
                <Route key={index} path={path} element={element} />
              ))}
            </Route>

            {/* User Routes */}
            <Route element={<ProtectedRoute allowedRoles={["subscriber"]} />}>
              <Route element={<MainLayout />}>
                <Route path="/subs/*" element={<UserRoutes />} />
              </Route>
            </Route>

            {/* Admin Routes */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
                <Route path="/*" element={<AdminRoutes />} />
            </Route>

          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
